import { API_URL } from "../config/config";
import { getRequest, patchRequest, putRequest } from "../utils/axiosUtils";
import moment from "moment";
import { formatStoredPhone, getDateFormat, getFilterQuery, getStatusLabel, timeFormat } from "../utils/helperFunction";

export const fetchAllWebLeads = async (
  {
  setRows,
  filterData = {},
  setRowCount,
  setLoading
}) => {
  try {
    setLoading && setLoading(true)
    const query = getFilterQuery(filterData)
    const url = `${API_URL}/leads/web/all${query}`;

    const response = await getRequest({url});

    if (response.status >= 200 && response.status < 300 && response.data) {
       const pagination = response.data?.pagination
      const options = (response.data?.data || []).map((item,idx) => ({
        sNo: (pagination?.page-1)*pagination.limit + (idx+1),
        id: item._id,
        leadId:item?.lead_details?.leadId || "-",
        lead_id:item?.lead_details?._id,
        name: item?.fullName || '-',
        logo: item?.email || '-',
        phone: item?.phone ? formatStoredPhone(item?.phone) : '-',
        email: item?.email || '-',
        gender: item?.gender || '-',
       state: item?.state || '-',
        city: item?.city || '-',
        dob: item.dob ? moment(item.dob).format("DD/MM/YYYY") : '-',
        returnVisit: item?.lead_details?.returnVisit || '0',
        course: item?.lead_details?.courseInterest || '-',
        leadSource:item?.lead_details?.utmData ? `${item?.lead_details?.utmData?.utm_campaign || "-"} | ${item?.lead_details?.utmData?.utm_medium || "-"} | ${item?.lead_details?.utmData?.utm_source || "-"}` : "-",
        source: item?.lead_details?.source || '-',
        assigncounsellor:item?.lead_details?.counselorId ? `${item?.lead_details?.counselorId?.firstName || ""} ${item?.lead_details?.counselorId?.lastName || ""}`.trim() : "-",
        date: getDateFormat(item?.createdAt),
        time: getDateFormat(item?.createdAt,"h:mm A"),
        lastLoginDate: getDateFormat(item?.lastLogin || item?.createdAt),
        lastLoginTime: getDateFormat(item?.lastLogin || item?.createdAt,"h:mm A"),
        status:item?.lead_details?.status ? getStatusLabel(item?.lead_details?.status) :  "-",
        isRegistrationDone:["registration_done","paid"]?.includes(item?.lead_details?.status),
      }));

      setRows(options);
      setRowCount && setRowCount(response.data?.pagination?.total || 0)
    } else {
      setRows([])
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error("fetchAllWebLeads error",error);
      setRows([])
     throw new Error(error?.response?.data?.message || 'Unknown error occurred');
  }finally{
    setLoading && setLoading(false)
  }
};

export const updateWebLeadStatus = async (_id, status) => {
  try {
    if (!_id || !status) {
      throw new Error('Lead ID and status are required')
    }
    const response = await patchRequest({
      url: `${API_URL}/leads/web/updateLeadStatus`,
      data: { status,_id},
    })
    if (response?.data?.success === false) {
      throw new Error(response.data.message || 'Status update failed')
    }
    return response.data
  } catch (error) {
      throw new Error(error?.response?.data?.message || `Failed to update details`);
  }
}

export const assignCounselorToWebLead = async ({setSaving,payload}) => {
  try {
    const {_id,counselorId} = payload

    if (!_id || !counselorId) {
      throw new Error('Counseling ID, counselor ID are required')
    }
    setSaving && setSaving(true)
    const response = await patchRequest({
      url: `${API_URL}/leads/web/assignCounselorToLead`,
      data: { _id,counselorId},
    })
  
    if (response?.data?.success === false) {
      throw new Error(response.data.message || 'Failed to assign councelor')
    }
  
    return response.data
    
  } catch (error) {
      throw new Error(error?.response?.data?.message || `Failed to assign counselor`);
  }finally{
    setSaving && setSaving(false)
  }
}

function formatSlugToTitle(url) {
  if (!url) return "";
  
  const cleanPath = url.split("?")[0];
  const parts = cleanPath.split("/").filter(Boolean);
  const slug = parts[parts.length - 1] || "";

  return slug
    .split("-")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

function getJourneyDetails(ele) {
  const title = formatSlugToTitle(ele?.pageUrl);

  if (ele?.type) {
    return {
      tag: ele.type,
      action: `Clicked on 'Explore ${ele.type}'`,
      description: `Navigated to ${ele.type} listing page`
    };
  }

  if (ele?.course?.abbreviation) {
    return {
      tag: "",
      action: `Selected Course: ${ele.course.abbreviation} ${ele?.specialization?.name || ""}`,
      description: `Viewed ${ele?.university?.universityName ? `${ele?.university?.universityName} course` : title}  details`
    };
  }

  if(ele?.pageUrl==="/"){
    return {
      tag: "",
      action: `Click on home page`,
      description: `Navigate to home page`
    }
  }

  return {
    tag: "",
    action: `Clicked on ${title}`,
    description: `Viewed ${title} details`
  };
}


export const fetchWebLeadDetails = async (
  {
  leadId,
  setDetails,
  setLoading
}) => {
  let details =null
  try {
    setLoading && setLoading(true)
    const url = `${API_URL}/leads/web/lead/${leadId}`;

    const response = await getRequest({url});

    if (response.status >= 200 && response.status < 300 && response.data) {
      const data = response.data?.data
      const signUpDate= data?.signUpAt ? moment(data?.signUpAt).format("DD/MM/YYYY") : '-'
      const signUpTime=  data.signUpAt ? moment(data?.signUpAt).format("h:mm A") : '-'
      details ={
        ...data,
        phone:data?.phone ? formatStoredPhone(data?.phone) :"",
        status:data?.status ? getStatusLabel(data?.status) : "-",
        isRegistrationDone:["registration_done","paid"]?.includes(data?.status),
        timeOnSite :timeFormat(data?.timeOnSite || 0),
        counselorName :`${data?.counselorId?.firstName || ""} ${data?.counselorId?.lastName || ""}`,
        signUpDate: signUpDate,
        signUpTime: signUpTime,
        lastLoginDate: data?.lastLogin ? moment(data?.lastLogin).format("DD/MM/YYYY") : signUpDate,
        lastLoginAtTime: data?.lastLogin ? moment(data?.lastLogin).format("h:mm A") : signUpTime,
        user_journeys: data?.user_journeys?.length ?
        data?.user_journeys?.map(ele=>{
           const { tag, action, description } = getJourneyDetails(ele);
          return {
              tag,action,description,
              date: getDateFormat(ele?.createdAt),
              time:getDateFormat(ele?.createdAt,"h:mm A"),
          }
        })
        :[],
        noteHistory: (data?.noteHistory || [])
          .map((ele) => {
            const createdAt = ele?.createdAt;
            return {
              ...ele,
              date: getDateFormat(createdAt),
              time: getDateFormat(createdAt, "h:mm A"),
            };
          })
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)),
        schedule_calls: (data?.schedule_calls || [])?.map(ele=>{
          return {
              ...ele,
              date: getDateFormat(ele?.dateTime),
              time:getDateFormat(ele?.dateTime,"h:mm A"),
          }
        }),
      }
    } else {
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error("fetchWebLeadDetails error",error);
     throw new Error(error?.response?.data?.message || 'Unknown error occurred');
  }finally{
    setLoading && setLoading(false)
    setDetails(details)
  }
};


export const fetchAllUtmType = async (
  {
setUtmTypeList
}) => {
  let options = {}
  try {

    const url = `${API_URL}/leads/web/lead/utmTypeList`;

    const response = await getRequest({url});

    if (response.status >= 200 && response.status < 300 && response.data?.data) {
      const data = response.data?.data
      if(typeof data==="object" && !Array.isArray(data)){
        const keys = Object.keys(data)
        keys?.forEach(key=>{
          options[key] = {
            list:["All","Generic",...data[key]],
            placeholder: `All ${key?.split("_")?.[1] || ""}`
          }
        })
      }
    } else {
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error("fetchAllWebLeads error",error);
     throw new Error(error?.response?.data?.message || 'Unknown error occurred');
  }finally{
    setUtmTypeList(options)
  }
};

export const addLeadNotes = async ({setSaving,payload}) => {
  try {
    const {_id,note} = payload

    if (!_id) throw new Error('Lead ID is required')
    if (!note) throw new Error('Note is required')

    
    setSaving && setSaving(true)
    const response = await putRequest({
      url: `${API_URL}/leads/web/addWebLeadsNotes`,
      data: payload,
    })
  
    if (response?.data?.success === false) {
      throw new Error(response.data.message || 'Failed to add note')
    }
  
    return response.data
    
  } catch (error) {
      throw new Error(error?.response?.data?.message || `Failed to add note`);
  }finally{
    setSaving && setSaving(false)
  }
}